import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { AddIcon, DropdownIcon, Remove, Share } from "../../Assest/icons";
import { useSelector } from "react-redux";
import apiClient from "../../apiClient";
import { GETALLBOARDS, DELETEBOARD, CREATEBOARD } from "../../apiClient/apiEndpoints";
import DeleteModal from "../Modals/DeleteModal";
import ShareModal from "../Modals/ShareModal";
import Skeleton from "react-loading-skeleton";
import { defaultLogo } from "../../env";
import NoResult from "./NoResult";
import moment from "moment";

const Dashboard = () => {
  const navigate = useNavigate();
  const configData = useSelector((state) => state.configSlice);
  const userId = useSelector((state) => state.userSlice)?.user?.uuid;
  const API_URL = configData?.config?.API_URL;
  const [boards, setBoards] = useState([]);
  const [unfilterBoardData, setunfilterBoardData] = useState([]);
  const [deleteData, setDeleteData] = useState({});
  const [showDelete, setShowDelete] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const handleCloseDelete = () => setShowDelete(false);
  const [shareMoadalData, setShareModalData] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchResult, setsearchResult] = useState(true);
  const boardSlice = useSelector((state) => state.boardSlice).boardSearch;

  const handleCloseShare = () => {
    setShowShare(false);
    getAllBoards();
  };
  async function deleteBoard(uuid, type, boardid) {
    try {
      const deleteBoard = await apiClient.put(`${API_URL}${DELETEBOARD}/${type}/${uuid}/${boardid}`);
      if (deleteBoard) {
        // setBoards((prevBoards) => {
        //   const updatedBoards = prevBoards.filter((ele) => ele.resource.uuid !== uuid);
        //   return updatedBoards;
        // });
        getAllBoards();
      }
    } catch (error) {}
  }
  async function getAllBoards() {
    try {
      setLoading(true);
      const boardAvailable = await apiClient.get(`${API_URL}${GETALLBOARDS}`);
      if (!boardAvailable) {
        setsearchResult(false);
        return;
      }
      setBoards(() => boardAvailable?.data);
      setunfilterBoardData(() => boardAvailable?.data);
      setLoading(false);
    } catch (error) {
    } finally {
    }
  }

  async function createBoard() {
    try {
      let body = {};
      body.title = `Untitled-${boards.length + 1}`;
      const board = await apiClient.post(`${API_URL}${CREATEBOARD}`, body);

      if (board) {
        navigate(`/board/${board?.accessType === "PUBLIC" ? "public" : "private"}/${board?.uuid}`);
      }
    } catch (error) {}
  }

  const viewBoard = (board) => {
    let accesstype = board?.accessType !== "PRIVATE" ? "public" : "private";
    navigate(`/board/${accesstype}/${board?.uuid}`);
  };

  const showDeleteModal = (uuid, type, boardid) => {
    const data = { uuid: uuid, type: type, boardid: boardid };
    setDeleteData(() => data);
    setShowDelete(true);
  };

  const showShareModal = (board) => {
    let data = {};
    data.id = board?.resource?.uuid;
    data.type = board?.resource?.accessType !== "PRIVATE" ? "public" : "private";
    setShareModalData(() => data);
    setShowShare(true);
  };

  const handleFilter = () => {
    const filter = unfilterBoardData.filter((board) => {
      let title = board.resource.title.toLowerCase();
      return title.includes(boardSlice.toLowerCase());
    });
    setBoards(() => filter);
  };
  useEffect(() => {
    handleFilter();
  }, [boardSlice]);

  useEffect(() => {
    if (API_URL) {
      getAllBoards();
    }
  }, [API_URL]);

  return (
    <>
      <div className="dashboard">
        {loading ? (
          <>
            <div className="main-list asset-list ">
              {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className="whiteboard-item">
                  <img class="img-fluid load-img-board " src={defaultLogo} alt="default-logo" />
                  <div className="info-detail">
                    <div className="user-data w-100 gap-0">
                      <p className="w-100">
                        {" "}
                        <Skeleton width="90%" height="0.8rem" />
                      </p>
                      <div className="owner-data w-100">
                        <Skeleton width="1.5REM" height="1.5REM" />
                        <p className="w-100">
                          <Skeleton width="90%" height="0.8rem" />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            {
              <>
                <div className="main-list asset-list ">
                  <div className="whiteboard-item add" onClick={() => createBoard()}>
                    <AddIcon />
                  </div>
                  {boards?.length ? (
                    boards?.map((board) => {
                      let placeholderName = board?.resource?.owner?.name
                        .split(" ")
                        .slice(0, 2)
                        .map((e) => e.split("")[0])
                        .join("")
                        .toUpperCase();
                      return (
                        <div className="whiteboard-item" key={board?.uuid}>
                          <div className="bthumbnail" onClick={() => viewBoard(board?.resource)}>
                            {/* <img class="img-fluid" src={board?.resource?.thumbnail || defaultLogo} alt="" /> */}
                            <img
                              className={`img-fluid ${board?.resource?.thumbnail ? "boardthumbnail" : "defaultlogo"}`}
                              src={board?.resource?.thumbnail || defaultLogo}
                              alt="Board Thumbnail"
                            />
                          </div>

                          <div className="info-detail">
                            <div className="user-data">
                              <div>
                                <p>{board?.resource?.title} </p>
                                {/* <p className="date">{board?.resource?.createdAt}</p> */}
                                <p className="date">
                                  <strong>Created At:</strong> {moment(board?.resource?.createdAt).calendar()}
                                </p>
                              </div>
                              <div className="owner-data">
                                {board?.resource?.owner?.avatar ? (
                                  <img src={board?.resource?.owner?.avatar} />
                                ) : (
                                  <span className="placeholder-">{placeholderName}</span>
                                )}
                                <p>{board?.resource?.owner?.name || "Untitled-username"}</p>
                              </div>
                            </div>
                            <div class="dropdown">
                              <DropdownIcon />
                              <ul class="listoption dropdown-menu  ">
                                <div className="options">
                                  {userId == board?.resource?.owner?.uuid && (
                                    <div
                                      className="option"
                                      onClick={() => {
                                        showDeleteModal(board?.resource?.uuid, board?.type, board?.uuid);
                                      }}
                                    >
                                      <Remove />
                                      Remove
                                    </div>
                                  )}
                                  <div className="option" onClick={() => showShareModal(board)}>
                                    <Share /> Share{" "}
                                  </div>
                                </div>
                              </ul>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : unfilterBoardData.length ? (
                    <NoResult />
                  ) : (
                    <NoResult message="Create New Board" />
                  )}
                </div>
              </>
            }
          </>
        )}
        <DeleteModal show={showDelete} onHide={handleCloseDelete} data={deleteData} deleteBoard={deleteBoard} />
        <ShareModal show={showShare} onHide={handleCloseShare} shareMoadalData={shareMoadalData} />
      </div>
    </>
  );
};

export default Dashboard;
